import { Skeleton } from '@/ui/components/primitives/skeleton'
import { Card, CardContent } from '@/ui/components/primitives/card'
import { cn } from '@/shared/utils'

export interface ContentSkeletonProps {
  /** Number of card/content blocks to show. @default 3 */
  blocks?: number
  className?: string
}

/**
 * Generic content skeleton for tabs and panels (gear, meals, photos, itinerary, etc.).
 * Use when the loaded content is a list of cards or a single card with multiple lines.
 */
export function ContentSkeleton({ blocks = 3, className }: ContentSkeletonProps) {
  return (
    <div className={cn('space-y-4', className)}>
      {Array.from({ length: blocks }).map((_, i) => (
        <Card key={i}>
          <CardContent className="p-6 space-y-4 animate-pulse">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-8 w-20 rounded-md" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-[85%]" />
              <Skeleton className="h-4 w-2/3" />
            </div>
            <div className="flex gap-2 pt-2">
              <Skeleton className="h-9 w-24 rounded-md" />
              <Skeleton className="h-9 w-24 rounded-md" />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
